__turbopack_context__.v({
  "about": "open-item-module-scss-module__E4nidG__about",
  "active": "open-item-module-scss-module__E4nidG__active",
  "arrowIcon": "open-item-module-scss-module__E4nidG__arrowIcon",
  "goTo": "open-item-module-scss-module__E4nidG__goTo",
  "itemgeneral": "open-item-module-scss-module__E4nidG__itemgeneral",
  "items": "open-item-module-scss-module__E4nidG__items",
  "name": "open-item-module-scss-module__E4nidG__name",
  "open": "open-item-module-scss-module__E4nidG__open",
  "openitem": "open-item-module-scss-module__E4nidG__openitem",
  "sidebarButton": "open-item-module-scss-module__E4nidG__sidebarButton",
});
